<script>
    import { Link } from "svelte-routing";
    import allContent from "../../data/content.json";

    const mathContent = allContent.filter(item => item.tags.includes("#math"));
    const subTags = [...new Set(mathContent.flatMap(item => item.tags).filter(t => t !== "#math"))].sort((a, b) => a.localeCompare(b, "ko"));

    let selectedTag = "";

    $: displayed = selectedTag
        ? mathContent.filter(item => item.tags.includes(selectedTag))
        : mathContent;

    function selectTag(tag) {
        selectedTag = selectedTag === tag ? "" : tag;
    }
</script>

<div class="page-shell category-page">
    <header class="cat-header">
        <span class="section-kicker">Mathematics</span>
        <h1>수학</h1>
        <span class="cat-count">{mathContent.length}개의 글</span>
    </header>

    <nav class="cat-filter" aria-label="수학 카테고리 필터">
        <button class="cat-tag" class:active={selectedTag === ""} on:click={() => selectTag("")}>전체</button>
        {#each subTags as tag}
            <button class="cat-tag" class:active={selectedTag === tag} on:click={() => selectTag(tag)}>{tag}</button>
        {/each}
    </nav>

    <div class="cat-list">
        {#each displayed as item}
            <Link to={`/content/${item.id}`} class="cat-item">
                <div class="cat-item-top">
                    <time>{item.date}</time>
                    <div class="cat-item-tags">
                        {#each item.tags.filter(t => t !== "#math").slice(0, 3) as tag}
                            <span>{tag}</span>
                        {/each}
                    </div>
                </div>
                <h2>{item.title}</h2>
                <p>{item.description}</p>
            </Link>
        {/each}
        {#if displayed.length === 0}
            <p class="empty">해당 태그에 일치하는 글이 없습니다.</p>
        {/if}
    </div>
</div>

<style>
    .category-page {
        display: flex;
        flex-direction: column;
        gap: 40px;
    }

    .cat-header {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .cat-header h1 {
        font-size: clamp(2.8rem, 5vw, 4.5rem);
        font-weight: 600;
        line-height: 1;
        letter-spacing: -0.035em;
    }

    .cat-header .section-kicker {
        color: var(--primary);
    }

    .cat-count {
        font-size: 0.88rem;
        color: var(--muted);
    }

    .cat-filter {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
    }

    .cat-tag {
        padding: 8px 18px;
        border: 1px solid var(--outline);
        border-radius: 100px;
        background: rgba(255, 255, 255, 0.6);
        backdrop-filter: blur(4px);
        -webkit-backdrop-filter: blur(4px);
        color: var(--muted);
        font-size: 0.82rem;
        font-weight: 500;
        cursor: pointer;
        transition: color 0.25s ease, background 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease;
    }

    .cat-tag:hover {
        color: var(--text);
        border-color: var(--line-strong);
        box-shadow: var(--shadow-sm);
    }

    .cat-tag.active {
        color: var(--on-primary);
        background: var(--primary);
        border-color: var(--primary);
        font-weight: 600;
        box-shadow: 0 2px 8px rgba(15, 98, 254, 0.2);
    }

    .cat-list {
        display: flex;
        flex-direction: column;
    }

    :global(a.cat-item) {
        text-decoration: none;
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding: 28px 0;
        border-bottom: 1px solid var(--outline);
        transition: padding-left 0.35s cubic-bezier(0.22, 1, 0.36, 1),
                    background 0.35s ease;
    }

    :global(a.cat-item:first-child) {
        border-top: 1px solid var(--outline);
    }

    :global(a.cat-item:hover) {
        padding-left: 12px;
    }

    .cat-item-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .cat-item-top time {
        font-size: 0.78rem;
        color: var(--muted);
        letter-spacing: 0.03em;
    }

    .cat-item-tags {
        display: flex;
        gap: 8px;
    }

    .cat-item-tags span {
        font-size: 0.75rem;
        color: var(--primary);
        opacity: 0.7;
    }

    :global(a.cat-item h2) {
        font-size: 1.3rem;
        font-weight: 700;
        color: var(--text);
        letter-spacing: -0.02em;
        line-height: 1.25;
        transition: color 0.25s ease;
    }

    :global(a.cat-item:hover h2) {
        color: var(--primary);
    }

    :global(a.cat-item p) {
        font-size: 0.94rem;
        color: var(--muted);
        line-height: 1.7;
    }

    .empty {
        text-align: center;
        padding: 60px 0;
        color: var(--muted);
    }

    @media (max-width: 900px) {
        .cat-item-top {
            flex-direction: column;
            align-items: flex-start;
            gap: 4px;
        }
    }
</style>
